
import { Button } from "@/components/ui/button";
import { PollListItem } from "@/components/PollListItem.tsx";
import { Poll } from "@/types/Poll.ts";
import { useState } from "react";

interface PollListProps {
  isLoading: boolean;
  polls: Poll[] | undefined;
  refetch: () => void;
}

export const PollList = ({ isLoading, polls, refetch }: PollListProps) => {
  const [page, setPage] = useState(1);
  const ITEMS_PER_PAGE = 8; // Increased from 6 to 8 for better pagination with 4 items per row

  const displayedPolls = polls?.slice(0, page * ITEMS_PER_PAGE);
  const hasMore = polls ? displayedPolls.length < polls.length : false;
  const isLoadingMore = isLoading && page > 1;

  const handleLoadMore = () => {
    setPage(prev => prev + 1);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-4 mt-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {displayedPolls?.map((poll: Poll) => (
          <PollListItem refetch={refetch} poll={poll} key={poll.id} />
        ))}
      </div>

      {hasMore && (
        <div className="flex justify-center mt-8">
          <Button
            onClick={handleLoadMore}
            className="bg-[#A7B49E] text-white hover:bg-[#A7B49E]/90 dark:bg-[#2C3930] dark:hover:bg-[#2C3930]/90"
            disabled={isLoadingMore}
          >
            {isLoadingMore ? "Loading..." : "Load More"}
          </Button>
        </div>
      )}
    </div>
  );
};
